import React, {useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {FieldArray, useFormikContext} from 'formik';
import PriceButton from './PriceButton/PriceButton';
import {Button} from '@tickchak/react-share/app';
import {add, dollar} from '../../../../../../assets/symbols/symbols/Symbols.css';
import PricingPop from '../../../pricingPop/PricingPop';
import useShow from '../../../../../../hooks/useShow';
import * as css from '../PricingStep/PricingStep.css';
import {SubscriptionFormValues, SubscriptionFormPrice as Price} from '../../createSubscriptionForm.types';

type ArrayHelpers = Parameters<React.ComponentProps<typeof FieldArray>['render']>[0];

function SubscriptionPriceSection() {
    const {t} = useTranslation('subscriptions');
    const {values, setFieldValue} = useFormikContext<SubscriptionFormValues>();
    const prices = values.prices || [];
    const selectedPrices = values.selectedPrices || [];
    const arrayHelpersRef = useRef<ArrayHelpers | null>(null);
    const pricingPopShow = useShow();
    const [priceId, setPriceId] = useState<number | string | null>(null);

    const getPriceLabel = (price: Price) => {
        const priceValue = price.price || 0;
        return `${price.name} ${priceValue}₪`;
    };

    const handleSavePricing = (pricingValues: any) => {
        if(priceId !== null && priceId !== undefined) {
            const priceIndex = prices.findIndex((price: Price) => price.id === priceId);
            if(priceIndex !== -1) {
                setFieldValue(`prices[${priceIndex}]`, {
                    ...prices[priceIndex],
                    ...pricingValues
                });
            }
        }
        else {
            if(arrayHelpersRef.current) {
                const newPrice: Price = {
                    id:null,
                    ...pricingValues
                };
                arrayHelpersRef.current.push(newPrice);
            }
        }
        setPriceId(null);
        pricingPopShow.close();
    };

    const handleEditPrice = (id: number | string) => {
        const price = prices.find((price: Price) => price.id === id);
        if(price) {
            setPriceId(id);
            pricingPopShow.open();
        }
    };

    const handleAddPrice = () => {
        setPriceId(null);
        pricingPopShow.open();

    };

    return (<css.sectionWrapper>
                <css.headerTitle $icon={dollar}>
                    {t('subscriptionPrice')}
                </css.headerTitle>
        <css.section>
            <FieldArray
                name="prices"
                render={arrayHelpers => {
                    arrayHelpersRef.current = arrayHelpers;
                    return (
                        <css.priceButtons>
                            {prices.map((price: Price, index: number) => {
                                const priceIdString = price.id?.toString();
                                return (
                                    <PriceButton
                                        key={priceIdString}
                                        label={getPriceLabel(price)}
                                        isSelected={selectedPrices.includes(priceIdString)}
                                        onSelect={() => handleEditPrice(price.id)}
                                        onEdit={() => handleEditPrice(price.id)}
                                        onDelete={() => {
                                            arrayHelpers.remove(index);
                                            if(priceIdString && selectedPrices.includes(priceIdString)) {
                                                setFieldValue('selectedPrices', selectedPrices.filter((p: string) => p !== priceIdString));
                                            }
                                        }}
                                    />
                                );
                            })}
                            <Button iconStart={<css.priceIcon icon={add} />} variant="brand" size="category" onClick={handleAddPrice} >{' '}</Button>
                        </css.priceButtons>
                    );
                }}
            />
            {pricingPopShow.isOpen && (
                <PricingPop
                    show={pricingPopShow}
                    onSave={handleSavePricing}
                    index={priceId !== null ? prices.findIndex((price: Price) => price.id === priceId) : -1}
                />
            )}
        </css.section>
        </css.sectionWrapper>
    );
}

export default SubscriptionPriceSection;

